import React from 'react'
import { connect } from 'react-redux'
import DynamicTable from '../../component/DynamicTable'
import productAction from '../../action/product'
import { localization, secondaryTableOptions, formatTotalElements, getQueryParams } from '../../helper/table'


function ProductsTable({ dispatch, totalCount }) {

  const fetchPaginatedData = query => dispatch(productAction.readPaginated(getQueryParams(query)))

  return (
    <DynamicTable
      columns={[
        { title: "Id", field: "id" },
        { title: "Uid", field: "product_id" },
        { title: "Titolo", field: "title" },
        { title: "Thumbnail", field: "thumb_filename" },
        { title: "Prezzo base", field: "base_price" },
        { title: "App", field: "app_title" },
        { title: "Abilitato", field: "is_disabled", render: rowData => !rowData.is_disabled ? 'Si' : 'No' },
        { title: "Extra", field: "extra" },
      ]}
      data={fetchPaginatedData}
      title={formatTotalElements(totalCount)}
      options={secondaryTableOptions}
      localization={localization}
    />
  )
}

const mapStateToProps = store => {
  const { product } = store
  return {
    totalCount: product.totalCount
  }
}


export default connect(mapStateToProps)(ProductsTable)